import { useFiles } from 'client/store'
import { getFileById } from 'client/store/files/filesSelectors'
import { BackgroundInterface } from 'common/types/background-interfaces'
import { getMobileBackgroundFileId } from 'common/utils/getMobileBackgroundFileId'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'

interface UseBackgroundImageInterface {
  backgroundFileId: BackgroundInterface['backgroundFileId']
  mobileBackgroundFileId: BackgroundInterface['backgroundFileId']
}

export const useBackgroundImage = ({
  backgroundFileId,
  mobileBackgroundFileId,
}: UseBackgroundImageInterface) => {
  const backgroundFile = useFiles(state => getFileById(state, backgroundFileId))

  const mobileBackgroundFile = useFiles(state =>
    getFileById(
      state,
      getMobileBackgroundFileId(backgroundFileId, mobileBackgroundFileId),
    ),
  )

  const backgroundImage = getBackgroundImageStyleValue(backgroundFile)

  const mobileBackgroundImage =
    getBackgroundImageStyleValue(mobileBackgroundFile)

  return { backgroundImage, mobileBackgroundImage }
}
